import axios from './http';
let qs = require('qs');
let base;
if (process.env.NODE_ENV == "development") {
  base = "/api"
} else if (process.env.NODE_ENV == "production") {
  base = ""
}
export const baseurl = params => {
  return `${base}`
}
console.log(process.env.NODE_ENV)
//获取平台
export const getPlatform = params => {
  return axios.get(`${base}/v2/dict/category/getPlatforms`, {
    params: params
  }).then(res => res.data);
};
//选题分类级联查询
export const getType = params => {
  return axios.get(`${base}/v2/dict/category/getType`, {
    params: params
  }).then(res => res.data);
};
//选题生成
export const insert = params => {
  return axios.post(`${base}/selectObject/insert`, params).then(res => res.data);
};
//获取所有提出者
export const getCreateUserId = params => {
  return axios.get(`${base}/selectObject/getCreateUserId`, {
    params: params
  }).then(res => res.data);
};
//获取所有作者
export const getContentAuthorIds = params => {
  return axios.get(`${base}/v2/content/getContentAuthorIds`, {
    params: params
  }).then(res => res.data);
};
//获取文章详情
export const getContent = params => {
  return axios.get(`${base}/v2/content/getContent/${params}`, ).then(res => res.data);
};
//查询内容数据打分页的页面数据：
export const NewgetContent = params => {
  return axios.get(`${base}/v2/content/statistic/v2/getScoreInfo`,{
    params: params
  }).then(res => res.data);
};
//选题状态更改
export const statusUpdate = params => {
  return axios.post(`${base}/v2/selsub/selectSubject/aduit`, qs.stringify(params)).then(res => res.data);
};
//修改选题
export const selectSubjectUpdate = params => {
  return axios.post(`${base}/v2/selsub/selectSubject/update`, params).then(res => res.data);
};
//删除选题
export const deleteTopic = params => {
  return axios.get(`${base}/v2/selsub/selectSubject/del/${params}`).then(res => res.data);
};

//信源查询
export const getSubjectSource = params => {
  return axios.post(`${base}/v2/source/subsou/getAllForOrder`, params).then(res => res.data);
};
//信源内容查询
export const sourceContent = params => {
  return axios.get(`${base}/v2/source/subsou/getContent`, {
    params: params
  }).then(res => res.data);
};
//频道查询
export const subjectSourceChannels = params => {
  return axios.get(`${base}/v2/source/subsou/subjectSourceChannels`, {
    params: params
  }).then(res => res.data);
};
//门户查询
export const sourceWebsites = params => {
  return axios.get(`${base}/v2/source/subsou/sourceWebsites`, {
    params: params
  }).then(res => res.data);
};
//领取信源
export const applySubject = params => {
  return axios.post(`${base}/v2/source/subsou/applySubject`, qs.stringify(params)).then(res => res.data);
};
//解除信源
export const releaseSource = params => {
  return axios.get(`${base}/v2/source/subsou/releaseSource/${params}`, ).then(res => res.data);
};

//选题分类管理 新增
export const addCategory = params => {
  return axios.post(`${base}/v2/dict/category/add`, params).then(res => res.data);
};
//选题分类管理 修改
export const updateCategoryName = params => {
  return axios.post(`${base}/v2/dict/category/update`, params).then(res => res.data);
};
//获取所有账户名
export const getAccountName = params => {
  return axios.get(`${base}/v2/wemedia/getAccountName`, {
    params: params
  }).then(res => res.data);
};
//获取所有作者
export const getAuthor = params => {
  return axios.get(`${base}/v2/score/getAuthor`, {
    params: params
  }).then(res => res.data);
};
//文章点评列表
export const getAllForOrder = params => {
  return axios.post(`${base}/v2/score/getAllForOrder`, qs.stringify(params)).then(res => res.data);
};
//文章点评打分
export const score = params => {
  return axios.post(`${base}/v2/score/scoring`, qs.stringify(params)).then(res => res.data);
};
//评分配置
export const getSetting = params => {
  return axios.get(`${base}/v2/score/getSetting`, {
    params: params
  }).then(res => res.data);
};
//改变CTR的值
export const changeCTR = params => {
  return axios.post(`${base}/v2/score/changeCTR`, qs.stringify(params)).then(res => res.data);
};
//改变阅读量得分和转赞评得分设置
export const changeSetting = params => {
  return axios.post(`${base}/v2/score/changeSetting`, qs.stringify(params)).then(res => res.data);
};
//关联选题
export const relationSelect = params => {
  return axios.get(`${base}/v2/score/relationSelect`, {
    params: params
  }).then(res => res.data);
};
//关联作者
export const relationAuthor = params => {
  return axios.get(`${base}v2/score/relationAuthor`, {
    params: params
  }).then(res => res.data);
};
//新增信源外采来源
export const externalProviderAdd = params => {
  return axios.post(`${base}/v2/dict/exter/add`, params).then(res => res.data);
};
//信源外采账号修改
export const externalProviderHomepage = params => {
  return axios.post(`${base}/v2/dict/exter/update`, params).then(res => res.data);
};
//信源外采来源查询
export const externalProviders = params => {
  return axios.post(`${base}/v2/dict/exter/getAllForOrder`, params).then(res => res.data);
};
//文章推送任务新增（确认发布）
export const addPlan = params => {
  return axios.post(`${base}/selectObject/content/push/addPlan`, params).then(res => res.data);
};
//文章推送任务删除（删除已设置推送任务）
export const deletePlan = params => {
  return axios.get(`${base}/selectObject/content/push/deletePlan`, {
    params: params
  }).then(res => res.data);
};
//文章推送任务表盘查询
export const planTable = params => {
  return axios.get(`${base}/selectObject/content/push/planTable`, {
    params: params
  }).then(res => res.data);
};
//文章推送任务列表查询
export const articlePlans = params => {
  return axios.get(`${base}/selectObject/content/push/articlePlans`, {
    params: params
  }).then(res => res.data);
};
//文章推送（失败重新推送）
export const outArticle = params => {
  return axios.get(`${base}/selectObject/content/push/outArticle`, {
    params: params
  }).then(res => res.data);
};
//文章同步老版本内容库
export const synchronizeToContent = params => {
  return axios.get(`${base}/selectObject/content/synchronizeToContent`, {
    params: params
  }).then(res => res.data);
};
//查询所有领域
export const getAlldomain = params => {
  return axios.get(`${base}/api/weMedia/domain/getAll`, {
    params: params
  }).then(res => res.data);
};
//图片列表（我的图片）
export const picturegetAllForOrder = params => {
  return axios.post(`${base}/v2/pic/picture/getAllForOrder`, params).then(res => res.data);
};
//新建图片（我的图片）
export const pictureinsert = params => {
  return axios.post(`${base}/v2/pic/picture/insert`, params).then(res => res.data);
};
//修改图片（我的图片）
export const pictureupdate = params => {
  return axios.post(`${base}/v2/pic/picture/update`, params).then(res => res.data);
};
//删除图片列（我的图片）
export const picturedelete = params => {
  return axios.get(`${base}/v2/pic/picture/delete`, {
    params: params
  }).then(res => res.data);
};
//新建分类
export const addcategory = params => {
  return axios.post(`${base}/v2/dict/category/add`, params).then(res => res.data);
};
//修改分类
export const updatecategory = params => {
  return axios.post(`${base}/v2/dict/category/update`, params).then(res => res.data);
};
//图片状态审核
export const modStatus = params => {
  return axios.post(`${base}/v2/pic/picture/modStatus`, qs.stringify(params)).then(res => res.data);
};
//选题申报
export const addselectSubject = params => {
  return axios.post(`${base}/v2/selsub/selectSubject/add`, params).then(res => res.data);
};
// 锁屏平台频道相关字典
export const fetchGetLockScreenDict = params => axios.get(`${base}/v2/dict/category/getLockScreenDict`, params).then(res => res.data)
// 锁屏选题申报
export const addLockSelectSubject = params => {
  return axios.post(`${base}/v2/lockscreenselsub/selectSubject/add`, params).then(res => res.data);
};
//选题列表
export const selectSubjectgetAllForOrder = params => {
  return axios.post(`${base}/v2/selsub/selectSubject/getAllForOrder`, params).then(res => res.data);
};
//校对列表
export const picture_content = params => {
  return axios.post(`${base}/v2/pic/pictureContent/getAllForOrder`, params).then(res => res.data);
};
//文章列表查询
export const v2getAllForOrder = params => {
  return axios.post(`${base}/v2/content/getAllForOrder`, params).then(res => res.data);
};
//新文章审核
export const v2articleAduit = params => {
  return axios.post(`${base}/v2/content/aduit`, qs.stringify(params)).then(res => res.data);
};
//校对审核
export const pictureContentaduit = params => {
  return axios.post(`${base}/v2/pic/pictureContent/aduit`, qs.stringify(params)).then(res => res.data);
};
// 权限管理
//我的菜单
export const myMenus = params => {
  return axios.get(`${base}/v2/menu/myMenus`, {
    params: params
  }, {
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    },

  }).then(res => res.data);
};
//创建菜单
export const Menucreate = params => {
  return axios.post(`${base}/v2/menu/create`, params).then(res => res.data);
};
//删除菜单
export const Menuremove = params => {
  return axios.get(`${base}/v2/menu/remove`, {
    params: params
  }).then(res => res.data);
};
//菜单列表
export const Menulist = params => {
  return axios.get(`${base}/v2/menu/list`, {
    params: params
  }).then(res => res.data);
};
//修改菜单
export const Menumodify = params => {
  return axios.post(`${base}/v2/menu/modify`, params).then(res => res.data);
};
//菜单添加到一个角色下边
export const addMenuToRole = params => {
  return axios.post(`${base}/v2/menu/addMenuToRole`, params).then(res => res.data);
};
//查询一个角色下边菜单列表
export const listMenuFormRole = params => {
  return axios.get(`${base}/v2/menu/listMenuFormRole`, {
    params: params
  }).then(res => res.data);
};
//从一个角色下边取消一个菜单
export const removeMenuFromRole = params => {
  return axios.get(`${base}/v2/menu/removeMenuFromRole`, {
    params: params
  }).then(res => res.data);
};
//创建角色
export const rolecreate = params => {
  return axios.post(`${base}/v2/role/create`, params).then(res => res.data);
};
//角色列表
export const rolelist = params => {
  return axios.get(`${base}/v2/role/list`, {
    params: params
  }).then(res => res.data);
};
//修改角色
export const rolemodify = params => {
  return axios.post(`${base}/v2/role/modify`, params).then(res => res.data);
};
//删除角色
export const removeRole = params => {
  return axios.get(`${base}/v2/role/removeRole`, {
    params: params
  }).then(res => res.data);
};
//创建url
export const urlcreate = params => {
  return axios.post(`${base}/v2/url/create`, params).then(res => res.data);
};
//修改url
export const urlmodify = params => {
  return axios.post(`${base}/v2/url/modify`, params).then(res => res.data);
};
//删除url
export const urlremove = params => {
  return axios.get(`${base}/v2/url/remove`, {
    params: params
  }).then(res => res.data);
};
//显示url列表
export const urllist = params => {
  return axios.get(`${base}/v2/url/list`, {
    params: params
  }).then(res => res.data);
};
//把url添加到菜单下面
export const addUrlToMenu = params => {
  return axios.post(`${base}/v2/url/addUrlToMenu`, params).then(res => res.data);
};
//查询一个菜单下边的url列表
export const listUrlFormMenu = params => {
  return axios.get(`${base}/v2/url/listUrlFormMenu`, {
    params: params
  }).then(res => res.data);
};
//从菜单下边取消一个URL
export const removeUrlFromMenu = params => {
  return axios.get(`${base}/v2/url/removeUrlFromMenu`, {
    params: params
  }).then(res => res.data);
};
//用户登录
export const Login = params => {
  return axios.post(`${base}/v2/user/login`, params).then(res => res.data);
};
//获取当前用户信息
export const myInfo = params => {
  return axios.get(`${base}/v2/user/myInfo`, params).then(res => res.data);
}
//用户列表及查询
export const userInfolist = params => {
  return axios.post(`${base}/v2/user/userInfo`, params).then(res => res.data);
};
//创建账号
export const createuser = params => {
  return axios.post(`${base}/v2/user/create`, params).then(res => res.data);
};
//修改账号密码
export const modifyuser = params => {
  return axios.post(`${base}/v2/user/resetPassword`, params).then(res => res.data);
};
//查询用户的角色
export const listRoleFormUser = params => {
  return axios.get(`${base}/v2/role/listRoleFormUser`, {
    params: params
  }).then(res => res.data);
};
//取消用户角色
export const removeRoleFromUser = params => {
  return axios.get(`${base}/v2/role/removeRoleFromUser`, {
    params: params
  }).then(res => res.data);
};
//添加用户角色
export const addRoleToUser = params => {
  return axios.post(`${base}/v2/role/addRoleToUser`, params).then(res => res.data);
};
//---------系统账号配置自媒体账号发布权限
//查询用户下的自媒体账号
export const adminUserAccount = params => {
  return axios.get(`${base}/v2/wemedia/adminUserAccount/getByUserId/${params}`).then(res => res.data);
};
//移除用户下的自媒体账号
export const removeAccountFromUser = params => {
  return axios.get(`${base}/v2/wemedia/adminUserAccount/removeAccountFromUser/${params}`).then(res => res.data);
};
//根据账号名称查询当前用户已经配置的平台
export const getByAccountName = params => {
  return axios.get(`${base}/v2/wemedia/adminUserAccount/getByAccountName/${params}`).then(res => res.data);
};
//用户配置自媒体账号
export const addAccountToUser = params => {
  return axios.post(`${base}/v2/wemedia/adminUserAccount/addAccountToUser`,
    params
  ).then(res => res.data);
};
//查询所有的自媒体账号名称
export const getAllAccountNames = params => {
  return axios.get(`${base}/v2/wemedia/getAllAccountNames`).then(res => res.data);
};


// 首页相关接口-按日期
export const indexDaily = params => {
  return axios.post(`${base}/v2/wemedia/indexDaily`,
    params
  ).then(res => res.data);
};
//获取作者
export const getAuthors = params => {
  return axios.get(`${base}/api/weMedia/getAuthors`, {
    params: params
  }).then(res => res.data);
};
//账号管理页-获取所有账号
export const alluserInfo = params => {
  return axios.get(`${base}/v2/wemedia/userInfoNew/getAllForOrder`, {
    params: params
  }).then(res => res.data);
};
// 账号管理页-新增账号
export const adduserInfo = params => {
  return axios.get(`${base}/v2/wemedia/userInfoNew/add`, {
    params: params
  }).then(res => res.data);
};
// 账号管理页-修改账号
export const updateuserInfo = params => {
  return axios.post(`${base}/v2/wemedia/userInfoNew/update`,
    qs.stringify(params)
  ).then(res => res.data);
};
//账号管理页-删除账号
export const deleteuserInfo = params => {
  return axios.get(`${base}/v2/wemedia/userInfoNew/delete`, {
    params: params
  }).then(res => res.data);
};
//修改账号启用状态接口
export const startupstatus = params => {
  return axios.get(`${base}/v2/wemedia/userInfoNew/changeAccType`, {
    params: params
  }).then(res => res.data);
};
//获取全部领域
export const getAllArea = params => {
  return axios.get(`${base}/v2/wemedia/domain/getAll`, {
    params: params
  }).then(res => res.data);
};
//增加领域
export const addArea = params => {
  return axios.get(`${base}/v2/wemedia/domain/add`, {
    params: params
  }).then(res => res.data);
};
//删除领域
export const deleteArea = params => {
  return axios.get(`${base}/v2/wemedia/domain/delete`, {
    params: params
  }).then(res => res.data);
};
//更新领域
export const updateArea = params => {
  return axios.get(`${base}/v2/wemedia/domain/update`, {
    params: params
  }).then(res => res.data);
};
//排行榜阀值新增或更新
export const thresholdUpdate = params => {
  return axios.get(`${base}/api/weMedia/sortConfig/update`, {
    params: params
  }).then(res => res.data);
};
//获取账号下所有的权益
export const getRights = params => {
  return axios.get(`${base}/api/weMedia/userInfoNew/getRight`, {
    params: params
  }).then(res => res.data)
}
//移除子账号
export const delSonAccount = params => {
  return axios.get(`${base}/v2/wemedia/userInfoNew/delSonAccount`, {
    params: params
  }).then(res => res.data);
};
//获取该账户名下所有的子账户
export const getAllSon = params => {
  return axios.get(`${base}/v2/wemedia/userInfoNew/getAllSon`, {
    params: params
  }).then(res => res.data);
};
//设置子账户
export const setMother = params => {
  return axios.get(`${base}/v2/wemedia/userInfoNew/setMother`, {
    params: params
  }).then(res => res.data);
};
//获取全部可设为子账户的账户
export const getUsableSon = params => {
  return axios.get(`${base}/v2/wemedia/userInfoNew/getUsableSon`, {
    params: params
  }).then(res => res.data);
};
// 新版MCN
//获取报题人、审题人
export const getUser = params => {
  return axios.get(`${base}/v2/selsub/selectSubject/getUser`, {
    params: params
  }).then(res => res.data);
};
//查询选题修改历史
export const getHis = params => {
  return axios.get(`${base}/v2/selsub/selectSubject/getHis/${params}`).then(res => res.data);
};
//选题下发
export const issus = params => {
  return axios.post(`${base}/v2/selsub/selectSubject/issus`, qs.stringify(params)).then(res => res.data);
};
//选题状态修改
export const selectSubjectaduit = params => {
  return axios.post(`${base}/v2/selsub/selectSubject/aduit`, qs.stringify(params)).then(res => res.data);
};
//获取选题提纲列表
export const getAllgrapOrder = params => {
  return axios.post(`${base}/v2/selsub/selectSubject/grapOrder/getAll`, qs.stringify(params)).then(res => res.data);
};
//提纲取用
export const confirmgrapOrder = params => {
  return axios.post(`${base}/v2/selsub/selectSubject/grapOrder/confirm`, qs.stringify(params)).then(res => res.data);
};
//交稿
export const subminLink = params => {
  return axios.post(`${base}/v2/selsub/selectSubject/subminLink`, qs.stringify(params)).then(res => res.data);
};
//查询所有小编账号
export const listUserFormRole = params => {
  return axios.post(`${base}/v2/role/listUserFormRole`, qs.stringify(params)).then(res => res.data);
};
//抢单
export const grapOrder = params => {
  return axios.post(`${base}/v2/selsub/selectSubject/grapOrder`, qs.stringify(params)).then(res => res.data);
};
//已抢单列表
export const listGrap = params => {
  return axios.post(`${base}/v2/selsub/selectSubject/listGrap`,
    params
  ).then(res => res.data);
};
//获取文章列表
export const AticlegetallForOrder = params => {
  return axios.post(`${base}/v2/content/getAllForOrder`,
    params
  ).then(res => res.data);
};
//自媒体下发级联查询
export const wemediamenu = params => {
  return axios.get(`${base}/v2/wemedia/userInfoNew/menu`, {
    params: params
  }).then(res => res.data);
};
//编辑自媒体下发级联查询
export const wemediaeditormenu = params => {
  return axios.get(`${base}/v2/wemedia/userInfoNew/editormenu`, {
    params: params
  }).then(res => res.data);
};
//自媒体推送列表
export const wemediagetAllForPush = params => {
  return axios.post(`${base}/v2/wemedia/getAllForPush`, qs.stringify(params)).then(res => res.data);
};
//添加推送任务
export const mcnpushadd = params => {
  return axios.post(`${base}/v2/mcnpush/add`, qs.stringify(params)).then(res => res.data);
};
//文章录入
export const addcontent = params => {
  return axios.post(`${base}/v2/content/add `, qs.stringify(params)).then(res => res.data);
};
//文章修改
export const wemediamodifycontent = params => {
  return axios.post(`${base}/v2/content/modify `, qs.stringify(params)).then(res => res.data);
};
//上传网络图片
//作废了
export const uploadPictureOLd = params => {
  return axios.post(`${base}/v2/oss/qiniu/uploadPicture`, qs.stringify(params)).then(res => res.data);
};
//上传网络图片
export const uploadPicture = params => {
  return axios.post(`${base}/v2/oss/oss/uploadPicture`, qs.stringify(params)).then(res => res.data);
};
//审稿人
export const getContentAduitUserIds = params => {
  return axios.get(`${base}/v2/content/getContentAduitUserIds`, {
    params: params
  }).then(res => res.data);
};
//创建账号（运营）
export const CreatecityUser = params => {
  return axios.post(`${base}/v2/cityUser/create`,
    params
  ).then(res => res.data);
};
//查询城市管理员下的写手列表
export const listCityWriter = params => {
  return axios.get(`${base}/v2/cityUser/listCityWriter`, {
    params: params
  }).then(res => res.data);
};
//查询城市管理员列表
export const listCityManager = params => {
  return axios.get(`${base}/v2/cityUser/listCityManager`, {
    params: params
  }).then(res => res.data);
};
//写手自查信息
export const cityUsermyInfo = params => {
  return axios.get(`${base}/v2/cityUser/myInfo`, {
    params: params
  }).then(res => res.data);
};
//获取银行卡号归属
export const validateAndCacheCardInfo = params => {
  return axios.get(`https://ccdcapi.alipay.com/validateAndCacheCardInfo.json?_input_charset=utf-8&cardBinCheck=true`, {
    params: params
  }).then(res => res.data);
};
//内容数据
export const statisticForOrder = params => {
  return axios.post(`${base}/v2/content/statistic/getAllForOrder`,
    params
  ).then(res => res.data);
};
//写手文章数据
export const statisticForOrder2 = params => {
  return axios.post(`${base}/v2/content/statistic/getAllForOrder2 `,
    params
  ).then(res => res.data);
};
//成员管理数据查询（主编）
export const UsergetAllForOrder = params => {
  return axios.post(`${base}/v2/content/statistic/user/getAllForOrder `,
    params
  ).then(res => res.data);
};
//管理员数据（运营）
export const CitygetAllForOrder = params => {
  return axios.post(`${base}/v2/content/statistic/city/getAllForOrder`,
    params
  ).then(res => res.data);
};
//写手数据（城市管理员）
export const WritergetAllForOrder = params => {
  return axios.post(`${base}/v2/content/statistic/writer/getAllForOrder`,
    params
  ).then(res => res.data);
};
//我的写手列表（城市管理员）
export const myWriters = params => {
  return axios.post(`${base}/v2/cityUser/myWriters `,
    params
  ).then(res => res.data);
};
//城市管理员总收益(城市管理员)
export const getCityIncome = params => {
  return axios.get(`${base}/v2/content/getCityIncome`, {
    params: params
  }).then(res => res.data);
};
//写手出勤 (写手)
export const getCreateCount = params => {
  return axios.get(`${base}/v2/content/getCreateCount`, {
    params: params
  }).then(res => res.data);
};
//写手收益(写手)
export const getWriterIncome = params => {
  return axios.get(`${base}/v2/content/getWriterIncome`, {
    params: params
  }).then(res => res.data);
};
//查询选题所有频道名
export const getChannels = params => {
  return axios.get(`${base}/v2/dict/category/getChannels`, {
    params: params
  }).then(res => res.data);
};
//查询城市管理者和写手列表
export const cityUserlistAll = params => {
  return axios.get(`${base}/v2/cityUser/listAll`, {
    params: params
  }).then(res => res.data);
};
//运营修改帐号
export const cityUsermodify = params => {
  return axios.post(`${base}/v2/cityUser/modify`,
    params
  ).then(res => res.data);
};
//帐号设置（用户自己修改）
export const myInfoUpdate = params => {
  return axios.post(`${base}/v2/cityUser/myInfoUpdate`,
    params
  ).then(res => res.data);
};
//注册
export const registercityUser = params => {
  return axios.post(`${base}/v2/cityUser/register`,
    params
  ).then(res => res.data);
};
//选题的写作列表
export const selectSubjectlistMasterGrap = params => {
  return axios.post(`${base}/v2/selsub/selectSubject/listMasterGrap`, params).then(res => res.data);
};
//判断用户名是否重复
export const checkNickName = params => {
  return axios.post(`${base}/v2/cityUser/checkNickName`, qs.stringify(params)).then(res => res.data);
};
//获取用户的详细信息
export const cityUserInfo = params => {
  return axios.get(`${base}/v2/cityUser/info`, {
    params: params
  }).then(res => res.data);
};
//内容数据文字打分
export const addscore = params => {
  return axios.post(`${base}/v2/content/score/add`, params).then(res => res.data);
};
//内容数据获取文章得分
export const scoregetById = params => {
  return axios.get(`${base}/v2/content/score/getById`, {
    params: params
  }).then(res => res.data);
};
//用户注册
export const register = params => {
  return axios.post(`${base}/v2/user/register`, params).then(res => res.data);
};
//入驻资料回显
export const myDetailInfo = params => {
  return axios.get(`${base}/v2/user/myDetailInfo`, {
    params: params
  }).then(res => res.data);
};
//入驻资料提交
export const completeInformation = params => {
  return axios.post(`${base}/v2/user/completeInformation`, params).then(res => res.data);
};
//选题不通过
export const selectSubjectreject = params => {
  return axios.post(`${base}/v2/selsub/selectSubject/reject`, qs.stringify(params)).then(res => res.data);
};
//文章不采纳
export const contentReject = params => {
  return axios.post(`${base}/v2/selsub/selectSubject/contentReject`, qs.stringify(params)).then(res => res.data);
};
//文章采纳
export const contentPass = params => {
  return axios.post(`${base}/v2/selsub/selectSubject/contentPass`, qs.stringify(params)).then(res => res.data);
};
//众包数据
export const writeruserData = params => {
  return axios.post(`${base}/v2/content/userData/writer`, params).then(res => res.data);
};
//众包人员
export const getUseruserData = params => {
  return axios.post(`${base}/v2/content/userData/getUser`, qs.stringify(params)).then(res => res.data);
};
//众包的下发文章查询
export const userDatagetContent = params => {
  return axios.post(`${base}/v2/content/userData/getContent`, qs.stringify(params)).then(res => res.data);
};
//类型
export const getFirstCategory = params => {
  return axios.get(`${base}/v2/dict/category/getFirstCategory`, {
    params: params
  }).then(res => res.data);
};
//分频道查询写手收益
export const writerincome = params => {
  return axios.post(`${base}/v2/content/userData/writer/income`, qs.stringify(params)).then(res => res.data);
};
//分频道查询写手收益
export const managerincome = params => {
  return axios.post(`${base}/v2/content/userData/manager/income`, qs.stringify(params)).then(res => res.data);
};
//写手整体收益查询
export const totalwriterIncome = params => {
  return axios.post(`${base}/v2/content/userData/writerIncome`, params).then(res => res.data);
};
//管理员数据（运营）
export const managerdata = params => {
  return axios.post(`${base}/v2/content/userData/manager/data`, params).then(res => res.data);
};
//-------二创-------
//文库列表
export const recreationarticle = params => {
  return axios.post(`${base}/v2/recreation/article/lists`, params).then(res => res.data);
};
//二次创作文章
export const recreationsubmit = params => {
  return axios.post(`${base}/v2/recreation/article/submit`,
    params).then(res => res.data);
};
//文库审核状态
export const recreationaudit = params => {
  return axios.post(`${base}/v2/recreation/article/audit`, params).then(res => res.data);
};
//二创批量放弃
export const batchGiveup = params => {
  return axios.post(`${base}/v2/recreation/article/batchGiveup`, params).then(res => res.data);
};
//写手领取二创内容
export const recreationgetOwn = params => {
  return axios.get(`${base}/v2/recreation/article/getOwn`, {
    params: params
  }).then(res => res.data);
};
//写手放弃文章
export const recreationabandon = params => {
  return axios.get(`${base}/v2/recreation/article/abandon`, {
    params: params
  }).then(res => res.data);
};
//二创文章详情
export const recreationdetail = params => {
  return axios.get(`${base}/v2/recreation/article/detail`, {
    params: params
  }).then(res => res.data);
};
//所有提出者
export const allSubmitors = params => {
  return axios.get(`${base}/v2/recreation/allSubmitors`, {
    params: params
  }).then(res => res.data);
};
//二创上一篇 下一篇
export const recreationgetPreOrNext = params => {
  return axios.get(`${base}/v2/recreation/article/getPreOrNext`, {
    params: params
  }).then(res => res.data);
};
//下载视频
export const videodownload = params => {
  return axios.get(`${base}/v2/oss/aliyun/video/download`, {
    params: params
  }).then(res => res.data);
};
//二创数据查询
export const recreationlists = params => {
  return axios.post(`${base}/v2/recreation/writerData/lists`, params).then(res => res.data);
};
//二创审核
export const allAuditors = params => {
  return axios.get(`${base}/v2/recreation/allAuditors`, {
    params: params
  }).then(res => res.data);
};

// 帐号数据-获取单独账号数据
export const Separate_account = params => {
  return axios.get(`${base}/v2/wemedia/indexDataForSingleAcount`, {
    params: params
  }).then(res => res.data);
};
//首页周月数据统计
export const weekOrMonthCount = params => {
  return axios.get(`${base}/v2/wemedia/weekOrMonthCount`, {
    params: params
  }).then(res => res.data);
};
//合伙人管理收益导出
export const managerexport = params => {
  return axios.get(`${base}/v2/content/userData/manager/export`, {
    params: params
  }).then(res => res.data);
};
//写手收益导出
export const writerxport = params => {
  return axios.get(`${base}/v2/content/userData/writer/export`, {
    params: params
  }).then(res => res.data);
};
//原创数据
export const statisticv2ForOrder = params => {
  return axios.post(`${base}/v2/content/statistic/v2/getAllForOrder`, params).then(res => res.data);
};
//文章数据(整合原创数据、众包数据)
export const getStatisticDataBySelectType = params => {
  return axios.post(`${base}/v2/content/statistic/v2/getStatisticDataBySelectType`, params).then(res => res.data);
};
//停止抢单
export const selsubstopGrap = params => {
  return axios.get(`${base}/v2/selsub/selectSubject/stopGrap`, {
    params: params
  }).then(res => res.data);
};
//主编首页查询主编所属小编数据
export const belongDatagetAll = params => {
  return axios.get(`${base}/v2/content/statistic/belongData/getAll`, {
    params: params
  }).then(res => res.data);
};
//主编首页昨日数据
export const belongDatagetUserId = params => {
  return axios.get(`${base}/v2/content/statistic/belongData/getUserId`, {
    params: params
  }).then(res => res.data);
};
//文章关联选题
export const relate = params => {
  return axios.get(`${base}/v2/content/statistic/relate`, {
    params: params
  }).then(res => res.data);
};

//联运-企业账号开户
export const enterpriseJoin = params => {
  return axios.post(`${base}/v2/joinUser/enterpriseJoin`, params).then(res => res.data);
};
//联运-个人账号开户
export const personalJoin = params => {
  return axios.post(`${base}/v2/joinUser/personalJoin`, params).then(res => res.data);
};
//改版后-账号开户
export const cooperatorJoin = params => {
  return axios.post(`${base}/v2/joinUser/cooperatorJoin`, params).then(res => res.data);
};
//用户激活审核通过
export const activePass = params => {
  return axios.post(`${base}/v2/joinUser/activePass`, params).then(res => res.data);
};
//用户激活审核打回
export const activeRefuse = params => {
  return axios.post(`${base}/v2/joinUser/activeRefuse`, params).then(res => res.data);
};
//联运-判断用户是否存在
export const userExists = params => {
  return axios.get(`${base}/v2/user/userExists`, {
    params: params
  }).then(res => res.data);
};
//联运-信息审核列表
export const getFinanceList = params => {
  return axios.post(`${base}/v2/joinUser/getFinanceList`, params).then(res => res.data);
};
//联运-账号信息审核
export const auditFinance = params => {
  return axios.post(`${base}/v2/joinUser/auditFinance`, params).then(res => res.data);
};
//联运-用户列表
export const userList = params => {
  return axios.post(`${base}/v2/joinUser/userList`, params).then(res => res.data);
};
//联运-账号下拉列表
export const paltAndFirmList = params => {
  return axios.get(`${base}/v2/cooperate/datainfo/paltAndFirmList`, params).then(res => res.data);
};
//联运-收益数据列表
export const adminIncomeList = params => {
  return axios.post(`${base}/v2/cooperate/datainfo/adminIncomeList`, params).then(res => res.data);
};
//联运-收益数据折线图
export const adminIncomeSums = params => {
  return axios.post(`${base}/v2/cooperate/datainfo/adminIncomeSums`, params).then(res => res.data);
};
//联运-收益数据 日期阶段数据
export const adminMultiDayIncome = params => {
  return axios.get(`${base}/v2/cooperate/datainfo/adminMultiDayIncome`, params).then(res => res.data);
};
//联运-用户收益列表
export const adminUserIncomeList = params => {
  return axios.post(`${base}/v2/cooperate/datainfo/adminUserIncomeList`, params).then(res => res.data);
};
//联运-用户收益折线图
export const adminUserIncomeSums = params => {
  return axios.post(`${base}/v2/cooperate/datainfo/adminUserIncomeSums`, params).then(res => res.data);
};
//联运-用户收益 日期阶段数据
export const adminMultiDayUserIncome = params => {
  return axios.get(`${base}/v2/cooperate/datainfo/adminMultiDayUserIncome`, params).then(res => res.data);
};

//二创源派发指定作者列表
export const activeUser = params => {
  return axios.get(`${base}/v2/recreation/activeUser`, {
    params: params
  }).then(res => res.data);
};
//联运-利润报表列表
export const adminProfit = params => {
  return axios.post(`${base}/v2/cooperate/datainfo/adminProfit`, params).then(res => res.data);
};
//联运-利润报表折线图
export const adminProfitSums = params => {
  return axios.post(`${base}/v2/cooperate/datainfo/adminProfitSums`, params).then(res => res.data);
};
//联运-自媒体阅读量列表
export const adminMatrixContentList = params => {
  return axios.post(`${base}/v2/cooperate/datainfo/adminMatrixContentList`, params).then(res => res.data);
};
//联运-自媒体阅读量折线图
export const adminMatrixContentSums = params => {
  return axios.post(`${base}/v2/cooperate/datainfo/adminMatrixContentSums`, params).then(res => res.data);
};
//联运-自媒体阅读量日期阶段数据
export const adminMultiDayMatrixContentSums = params => {
  return axios.get(`${base}/v2/cooperate/datainfo/adminMultiDayMatrixContentSums`, params).then(res => res.data);
};
//联运-厂商阅读量列表
export const adminFirmContentList = params => {
  return axios.post(`${base}/v2/cooperate/datainfo/adminFirmContentList`, params).then(res => res.data);
};
//联运-厂商阅读量折线图
export const adminFirmContentSums = params => {
  return axios.post(`${base}/v2/cooperate/datainfo/adminFirmContentSums`, params).then(res => res.data);
};
//联运-厂商阅读量日期阶段数据
export const adminMultiDayFirmContentSums = params => {
  return axios.get(`${base}/v2/cooperate/datainfo/adminMultiDayFirmContentSums`, params).then(res => res.data);
};
//联运-参数调节 默认流量系数
export const deaultPvRatio = params => {
  return axios.get(`${base}/v2/cooperate/datainfo/deaultPvRatio`, {
    params: params
  }).then(res => res.data);
};
//联运-修改默认系数
export const modifyDeaultPvRatio = params => {
  return axios.post(`${base}/v2/cooperate/datainfo/modifyDeaultPvRatio`, params).then(res => res.data);
};
//联运-入驻用户当前的流量系数
export const userPvRatio = params => {
  return axios.get(`${base}/v2/cooperate/datainfo/userPvRatio`, {
    params: params
  }).then(res => res.data);
};
//联运-调整用户的流量系数
export const adjustPvRatio = params => {
  return axios.post(`${base}/v2/cooperate/datainfo/adjustPvRatio`, params).then(res => res.data);
};
//联运-移除特殊流量系数
export const removeRatioSpecial = params => {
  return axios.get(`${base}/v2/cooperate/datainfo/removeRatioSpecial`, {
    params: params
  }).then(res => res.data);
};
//联运-入驻用户流量系数参数调节列表
export const userPvRatioList = params => {
  return axios.post(`${base}/v2/cooperate/datainfo/userPvRatioList`, params).then(res => res.data);
};
//联运-提现管理列表
export const adminBalances = params => {
  return axios.post(`${base}/v2/cooperate/datainfo/adminBalances`, params).then(res => res.data);
};
//联运-提现管理 账单明细
export const adminBalanceDetail = params => {
  return axios.post(`${base}/v2/cooperate/datainfo/adminBalanceDetail`, params).then(res => res.data);
};
//联运-提现管理 提现审核
export const cashOutAudit = params => {
  return axios.post(`${base}/v2/cooperate/datainfo/cashOutAudit`, params).then(res => res.data);
};
//联运-提现管理 提现相关状态
export const cashOutStatus = params => {
  return axios.post(`${base}/v2/cooperate/datainfo/cashOutStatus`, params).then(res => res.data);
};
//联运账号资料
export const adminUserInfo = params => {
  return axios.get(`${base}/v2/joinUser/adminUserInfo`, {
    params: params
  }).then(res => res.data);
};
//联运封禁用户
export const forbidUser = params => {
  return axios.post(`${base}/v2/joinUser/forbidUser`, params).then(res => res.data);
};
//联运解禁用户
export const openUser = params => {
  return axios.post(`${base}/v2/joinUser/openUser`, params).then(res => res.data);
};
//联运开启/停止账号
export const closeOrOpen = params => {
  return axios.post(`${base}/v2/joinUser/closeOrOpen`, params).then(res => res.data);
};
//联运添加账号
export const addAccounts = params => {
  return axios.post(`${base}/v2/joinUser/addAccounts`, params).then(res => res.data);
};
//二创vivo可强推的分类
export const handoutCategorys = params => {
  return axios.get(`${base}/v2/mcnpush/handoutCategorys`, {
    params: params
  }).then(res => res.data);
};
//二创文章强推
export const handout = params => {
  return axios.post(`${base}/v2/recreation/article/handout`, params).then(res => res.data);
};
//二创所有可以推送的厂商
export const handoutMarket = params => {
  return axios.post(`${base}/v2/recreation/article/handoutMarket`, params).then(res => res.data);
};
//二创报表
export const dailyCount = params => {
  return axios.post(`${base}/v2/recreation/article/dailyCount`, params).then(res => res.data);
};
//二创报表导出
export const dailyCountExport = params => {
  return axios.get(`${base}/v2/recreation/article/dailyCountExport`,{
	  params: params,responseType: 'blob'
	}).then(res => res);
};

//放弃
export const giveup = params => {
  return axios.get(`${base}/v2/recreation/article/giveup`, {
    params: params
  }).then(res => res.data);
};
//按频道和角色查询下作者
export const channelusers = params => {
  return axios.get(`${base}/v2/channel/users`, {
    params: params
  }).then(res => res.data);
};
//二创专栏列表查询
export const specialCollist = params => {
  return axios.post(`${base}/v2/recreation/specialCol/list`, params).then(res => res.data);
};
//二创专栏新增
export const specialColadd = params => {
  return axios.post(`${base}/v2/recreation/specialCol/add`, params).then(res => res.data);
};
//二创专栏修改
export const specialColupdate = params => {
  return axios.post(`${base}/v2/recreation/specialCol/update`, params).then(res => res.data);
};
//百度统计-数据分类
export const baidusite = params => {
  return axios.get(`${base}/v2/mcnpush/baidu/get/site`, {
    params: params
  }).then(res => res.data);
};
//百度统计-Top100
export const baidutop = params => {
  return axios.post(`${base}/v2/mcnpush/baidu/get/top`, params).then(res => res.data);
};
//编译内容
//写手-编译文章列表
export const writerArticles = params => {
  return axios.post(`${base}/v2/compile/article/writerArticles`, params).then(res => res.data);
};
//审核-编译文章列表
export const compileArticles = params => {
  return axios.post(`${base}/v2/compile/article/lists`, params).then(res => res.data);
};
//编译单点审核内容查询
export const auditDetail = params => {
  return axios.get(`${base}/v2/compile/article/auditDetail`, {
    params: params
  }).then(res => res.data);
};
//编译内容查询
export const compiledetail = params => {
  return axios.get(`${base}/v2/compile/article/detail`, {
    params: params
  }).then(res => res.data);
};
//编译提交文章
export const compileSubmit = params => {
  return axios.post(`${base}/v2/compile/article/submit`, params).then(res => res.data);
};
//写手放弃编译文章
export const compileabandon = params => {
  return axios.get(`${base}/v2/compile/article/abandon`, {
    params: params
  }).then(res => res.data);
};
//主管放弃文章
export const compileagiveup = params => {
  return axios.get(`${base}/v2/compile/article/giveup`, {
    params: params
  }).then(res => res.data);
};
//编译文章审核
export const compileAudit = params => {
  return axios.post(`${base}/v2/compile/article/audit`, params).then(res => res.data);
};
//编译文章文库下发
export const articleLibPick = params => {
  return axios.post(`${base}/v2/compile/article/articleLibPick`, params).then(res => res.data);
};
//编译文章领取
export const compilegetOwn = params => {
  return axios.get(`${base}/v2/compile/article/getOwn`, {
    params: params
  }).then(res => res.data);
};
//编译文章上一篇 下一篇
export const compilePreOrNext = params => {
  return axios.get(`${base}/v2/compile/article/getPreOrNext`, {
    params: params
  }).then(res => res.data);
};
//所有提交者
export const compileAllSubmitors = params => {
  return axios.get(`${base}/v2/compile/allSubmitors`, {
    params: params
  }).then(res => res.data);
};
//编译活跃作者
export const compileActiveUser = params => {
  return axios.get(`${base}/v2/compile/activeUser`, {
    params: params
  }).then(res => res.data);
};
//创建编译文库
export const selfCreate = params => {
  return axios.post(`${base}/v2/compile/article/selfCreate`, params).then(res => res.data);
};



//图库
//七牛
export const picture_token = params => {
  return axios.get(`${base}/v2/oss/qiniu/picture/token`, params).then(res => res.data);
};
//删除图片
export const remove_picture = params => {
  return axios.post(`${base}/v2/gallery/remove/picture`, params).then(res => res.data);
};
//编辑图片
export const modify_gallery = params => {
  return axios.post(`${base}/v2/gallery/modify/gallery`, params).then(res => res.data);
};

//通过图库id 查询图片基本信息
export const gallery = params => {
  return axios.get(`${base}/v2/gallery/getById/gallery`, {
    params: params
  }).then(res => res.data);
};
//图片状态修改
export const examine = params => {
  return axios.post(`${base}/v2/gallery/examine/gallery`, params).then(res => res.data);
};
//审核状态分类
export const get_count = params => {
  return axios.get(`${base}/v2/gallery/get/count`, {
    params: params
  }).then(res => res.data);
};
//上传图片
export const upload_picture = params => {
  return axios.post(`${base}/v2/gallery/upload/picture`, params).then(res => res.data);
};
//创建
export const save_pictureInfo = params => {
  return axios.post(`${base}/v2/gallery/save/picture`, params).then(res => res.data);
};
//成品库
export const post_pictureInfo = params => {
  return axios.post(`${base}/v2/gallery/post/pictureInfo`, params).then(res => res.data);
};
//图片分类
export const dict_getType = params => {
  return axios.get(`${base}/v2/dict/category/getType?parentId=0&type=10`, {
    params: params
  }).then(res => res.data);
};
//用户查看提交图片信息
export const getUser_pictureInfo = params => {
  return axios.post(`${base}/v2/gallery/getUser/pictureInfo`, params).then(res => res.data);
};
//分类获取音乐
export const listByCategory = params => {
  return axios.post(`https://pre-online.17aifun.com/v2/AT/music/listByCategory`, qs.stringify(params)).then(res => res.data);
};
//获取音乐详情
export const playUrl = params => {
  return axios.post(`https://pre-online.17aifun.com/v2/AT/music/playUrl`, qs.stringify(params)).then(res => res.data);
};
//编译获取审核者
export const compileAllAuditors = params => {
  return axios.get(`${base}/v2/compile/allAuditors`, {
    params: params
  }).then(res => res.data);
};
//编译获取派发者
export const compilePicktorIds = params => {
  return axios.get(`${base}/v2/compile/allPicktors`, {
    params: params
  }).then(res => res.data);
};
//所有信源（编译）
export const compileallPlats = params => {
  return axios.get(`${base}/v2/compile/allPlats`, {
    params: params
  }).then(res => res.data);
};
//自动发布
export const compileadd = params => {
  return axios.post(`${base}/v2/selsub/selectSubject/compileadd`, params).then(res => res.data);
};
//编译强推
export const compilehandout = params => {
  return axios.post(`${base}/v2/compile/article/handout`, params).then(res => res.data);
};
//同步加美
export const pushToToronto = params => {
  return axios.get(`${base}/v2/compile/article/pushToToronto`, {
    params: params
  }).then(res => res.data);
};
//主编-原创数据导出
export const getAllForOrderExport = params => {
  return axios.get(`${base}/v2/content/statistic/getAllForOrderExport`, {
    params: params,responseType: 'blob'
  }).then(res => res);
};
//主编-文章数据导出（整合原创数据、众包数据）
export const getAllForOrderSelectTypeExport = params => {
  return axios.get(`${base}/v2/content/statistic/v2/getStatisticDataBySelectTypeExport`, {
    params: params,responseType: 'blob'
  }).then(res => res);
};
//查询所有后期制作人
export const getLaterStageProducerIds = params => {
  return axios.get(`${base}/v2/content/getLaterStageProducerIds`,{
    params: params
  }).then(res => res);
};
//主编-账号数据-单独账号数据导出
export const indexDataForSingleAcountExport = params => {
	return axios.get(`${base}/v2/wemedia/indexDataForSingleAcountExport`, {
	  params: params,responseType: 'blob'
	}).then(res => res);
  };
//主编-账号数据-周月统计数据导出
export const weekOrMonthCountExcel = params => {
	return axios.get(`${base}/v2/wemedia/weekOrMonthCountExcel`, {
	  params: params,responseType: 'blob'
	}).then(res => res);
};
//设置视频后期制作人
export const addLaterStageProducer = params => {
	return axios.get(`${base}/v2/selsub/selectSubject/addLaterStageProducer`,  {
    params: params
  }).then(res => res);
};
//获取视频后期制作人
export const listUserFormRoleCode = params => {
	return axios.get(`${base}/v2/role/listUserFormRoleCode`,  {
    params: params
  }).then(res => res);
};

// 锁屏平台频道相关信息字典查询
export const getChannelsInLock = params => axios.post(`${base}/v2/user/register`, { params });



// WEBPACK FOOTER //
// ./src/api.js